<template>
  <div class="home-content-page-v">
    <div class="ele-case">
      <div class="choose-cases">
        <a href="javascript:;" class="one-case" v-for="data in casesEle">
          <div class="case-name">{{data.name}}</div>
          <div class="case-info">
            <div class="case-info-one">
              <span>天气</span><span>{{data.d1}}</span>
            </div>
            <div class="case-info-one">
              <span>光伏成本</span><span>{{data.d2}}</span>
            </div>
            <div class="case-info-one">
              <span>固定存储容量</span><span>{{data.d3}}</span>
            </div>
            <div class="case-info-one">
              <span>SOC下限</span><span>{{data.d4}}</span>
            </div>
            <div class="case-info-one">
              <span>SOC上限</span><span>{{data.d5}}</span>
            </div>
            <div class="case-info-one">
              <span>SOC初始值</span><span>{{data.d6}}</span>
            </div>
            <div class="case-info-one">
              <span>储能放电成本</span><span>{{data.d7}}</span>
            </div>
            <!-- <a href="javascript:;" @click="chooseCase(data)" class="case-action" v-if="data.status === 30">
              <template v-if="allSaveCasesName.indexOf(data.name) === -1">
                <i class="iconfont icon-save"></i><span>存储到本地</span>
              </template>
              <template v-else>
                <i class="iconfont icon-delete"></i><span>删除存储</span>
              </template>
            </a> -->
          </div>
          <div class="case-checked" :class="{'status-dh': data.status !== 30}">
            <span class="case-checked-text">
              {{status_text[String(data.status)]}}
            </span>
          </div>
        </a>
        <a href="javascript:;" class="add-case" @click="showAdd"><i class="iconfont icon-addfriend"></i><span>新增方案</span></a>
        <a href="javascript:;" class="add-case" @click="showImport=true"><i class="iconfont icon-daoru"></i><span>导入方案</span></a>
      </div>
    </div>
    <el-dialog title="新增方案" :visible.sync="addCase">
      <div class="case-form">
        <div class="one-input">
          <span>方案名称</span>
          <el-input v-model="newCase.name" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>天气</span>
          <el-select v-model="newCase.d1" size="small" placeholder="请选择">
            <el-option v-for="item in weathers" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="one-input">
          <span>光伏成本</span>
          <el-select v-model="newCase.d2" size="small" placeholder="请选择">
            <el-option v-for="item in datas1" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="one-input">
          <span>固定存储容量</span>
          <el-select v-model="newCase.d3" size="small" placeholder="请选择">
            <el-option v-for="item in datas2" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="one-input">
          <span>SOC下限</span>
          <el-select v-model="newCase.d4" size="small" placeholder="请选择">
            <el-option v-for="item in datas3" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="one-input">
          <span>SOC上限</span>
          <el-select v-model="newCase.d5" size="small" placeholder="请选择">
            <el-option v-for="item in datas4" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="one-input">
          <span>SOC初始值</span>
          <el-select v-model="newCase.d6" size="small" placeholder="请选择">
            <el-option v-for="item in datas5" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="one-input">
          <span>储能放电成本</span>
          <el-select v-model="newCase.d7" size="small" placeholder="请选择">
            <el-option v-for="item in datas6" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addCase = false">取 消</el-button>
        <el-button type="primary" @click="addNewCase">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="导入方案" :visible.sync="showImport" size="tiny">
      <el-checkbox-group v-model="importCases" size="small" fill="#324057" text-color="#a4aebd">
        <el-checkbox-button v-for="data in allSaveCasesName" :label="data" :disabled="testImported(data)" :key="data">{{data}}</el-checkbox-button>
      </el-checkbox-group>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showImport = false">取 消</el-button>
        <el-button type="primary" @click="importCase">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import ContentTitle from '../../components_bit/ContentTitle'
  export default {
    components: {
      ContentTitle
    },
    data () {
      return {
        showImport: false,
        importCases: [],
        newCase: {
          name: '',
          d1: '雨天',
          d2: 0,
          d3: '4500kWh',
          d4: 0.01,
          d5: 0.99,
          d6: 0.5,
          d7: 0,
          // 0 start 10 新增完成 20 求解中 30 求解完成
          status: 0,
          result: {}
        },
        status_text: {
          '0': 'start',
          '10': '新增完成',
          '20': '求解中。。。',
          '30': '求解完成'
        },
        addCase: false,
        weathers: ['晴天', '雨天'],
        datas1: [0, 0.5, -0.42],
        datas2: ['4500kWh', '100kWh'],
        datas3: [0.3, 0.1, 0.01],
        datas4: [0.95, 0.99],
        datas5: [0.5],
        datas6: [0, 0.2]
      }
    },
    methods: {
      testImported (caseName) {
        let data = false
        this.casesEle.forEach(function (item) {
          if (caseName === item.name) {
            data = true
          }
        })
        return data
      },
      importCase () {
        this.showImport = false
        this.$store.dispatch('oupoutEleCase', this.importCases)
        this.importCases = []
      },
      chooseCase (data) {
        if (this.allSaveCasesName.indexOf(data.name) > -1) {
          this.$store.dispatch('clearOneEleCase', data.name)
        } else {
          this.$store.dispatch('saveOneEleCase', data)
        }
      },
      showAdd () {
        this.addCase = true
        this.newCase = {
          name: '方案' + (this.casesEle.length + 1),
          d1: '雨天',
          d2: 0,
          d3: '4500kWh',
          d4: 0.01,
          d5: 0.99,
          d6: 0.5,
          d7: 0,
          status: 0,
          result: {}
        }
      },
      addNewCase () {
        this.addCase = false
        this.$store.dispatch('addCasesEle', this.newCase)
      }
    },
    computed: {
      eleStatus: {
        get () {
          return this.$store.getters.eleStatus
        }
      },
      allSaveCasesName: {
        get () {
          return this.$store.getters.allSaveCasesName
        }
      },
      casesEle: {
        get () {
          return this.$store.getters.casesEle
        }
      }
    },
    created () {
      if (this.eleStatus < 10) {
        this.$router.push({name: 'ele_import'})
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../../style/base.less';
  .case-action {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    color: @bak-color-2;
    background-color: rgba(255,255,255, 0.8);
    display: none;
    font-size: 1.2rem;
    flex-direction:column;
    align-items: center;
    justify-content: center;
    i {
      font-size: 2rem;
      margin-bottom: 0.7rem;
    }
  }
  .progress-ok {
    text-align: right;
    transition: 0.5s;
    background-image: linear-gradient(to bottom, #0084f3, #00346f);
  }
  .case-form {
    display: flex;
    flex-wrap: wrap;
  }
  .one-input {
    display: flex;
    justify-content: space-between;
    width: 46%;
    margin: 1rem 2%;
    span {
      width: 9rem;
      font-size: 0.9rem;
    }
  }
  .ele-case {
    flex: 1;
    background: #fff;
    overflow: hidden;
    display: flex;
    flex-direction:column;
  }
  .choose-cases {
    display: flex;
    overflow: auto;
    flex-wrap: wrap;
  }
  .one-case {
    display: flex;
    flex-direction:column;
    margin: 1rem 1%;
    width: 18%;
    background: #eee;
  }
  .add-case {
    border-radius: 1rem;
    flex-direction:column;
    display: flex;
    margin: 1rem 1%;
    font-size: 7rem;
    color: @bak-color-2;
    align-items: center;
    justify-content: center;
    width: 18%;
    height: 13rem;
    background: #eee;
    line-height: 1;
    span {
      font-size: 1.5rem;
    }
    i {
      font-size: 3rem;
      margin-bottom: 2.5rem;
    }
  }
  .status-dh {
    animation: myfirst 3s infinite;
  }
  @keyframes myfirst
  {
    0% {background: #9dc2e4;}
    50% {background: #e1e1e1;}
    100% {background: #9dc2e4;}
  }
  .case-name {
    text-align: center;
    line-height: 2rem;
    font-size: 0.7rem;
    border-top-right-radius: 0.5rem;
    border-top-left-radius: 0.5rem;
    color: #fff;
    background-color: #1c73cd;
  }
  .case-info {
    display: flex;
    padding: 1rem;
    color: #666;
    flex-direction:column;
    background: #eee;
    position: relative;
  }
  .case-info:hover {
    .case-action {
      display: flex;
    }
  }
  .case-info-one {
    display: flex;
    justify-content: space-between;
  }
  .case-checked-text {
    position: absolute;
    color: #fff;
    top: 0.4rem;
  }
  .case-checked {
    display: flex;
    position: relative;
    justify-content:center;
    background: #0564b9;
    border-bottom-right-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
    font-size: 0.7rem;
    height: 1.9rem;
    color: #777;
  }
</style>



// WEBPACK FOOTER //
// ele_case.vue?558eccef